const formatResultDate = (dateString) => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

const HiLowResult = ({
  resultData
}) => {
  return (
    <div id="ResultsData" class="tabcontent" style={{ display: "block" }}>
      <div class="left-content">
        {resultData &&
          resultData.length > 0 &&
          resultData.map((dataObj, index) => {
            let win1 = (dataObj.result == 1) ? 'WINNER' : 'LOSER';
            let win2 = (dataObj.result == 3) ? 'WINNER' : 'LOSER';
            let win3 = (dataObj.result == 2) ? 'WINNER' : 'LOSER';

            let resultVal = dataObj.result;
            let reusutlRnr = '';
            if (resultVal == 1) {
              reusutlRnr = 'High';
            }
            if (resultVal == 3) {
              reusutlRnr = 'Snap';
            }
            if (resultVal == 2) {
              reusutlRnr = 'Low';
            }

            let imgVal = `/assets/images/cards/${dataObj.c1}.svg`;
            let imgVal2 = `/assets/images/cards/${dataObj.c2}.svg`;
            return (
              <div
                class="card"
                style={{
                  border: "1px solid rgb(204, 204, 204)",
                  borderRadius: "8px",
                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                  marginBottom: "5px",
                  background: "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                  color: "white"
                }}
              >
                <div
                  class="card-header no-border"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "10px",
                    marginTop: "10px",
                    marginLeft: "7px",
                    background: "transparent",
                    borderBottom: "solid 1px #000"
                  }}
                >
                  {formatResultDate(dataObj.evt_od)} - <b>ID=</b> {dataObj._id}
                </div>
                <div class="card-body">
                  <div
                    class="players-table"
                    style={{ textAlign: "center", width: "100%" }}
                  >
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-evenly", background: "transparent" }}>

                          <td class="TdResults">
                            <div class="player-cards" style={{ display: "flex", flexDirection: "column", alignItems: "center", overflowWrap: "break-word" }}>
                              <div class="player-name" style={{ fontWeight: "bold", textAlign: "center" }}>
                                Community Cards
                              </div>
                              <div class="card-images" style={{ display: "flex", justifyContent: "center", gap: "3px", flexWrap: "wrap" }}>
                                <img src={imgVal} loading="lazy" style={{ width: "40px", height: "60px", objectFit: "cover", borderRadius: "5px" }} />
                                <img src={imgVal2} loading="lazy" style={{ width: "40px", height: "60px", objectFit: "cover", borderRadius: "5px" }} />
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-evenly", background: "transparent" }}>
                          <td class="TdResults TdResultsWin">
                            <div class="player-cards" style={{ display: "flex", flexDirection: "column", alignItems: "center", overflowWrap: "break-word" }}>
                              <div class="player-name" style={{ fontWeight: "bold", textAlign: "center", width: "100%" }}>
                                {reusutlRnr}
                              </div>
                              <div class="card-images" style={{ display: "flex", justifyContent: "center", gap: "3px", flexWrap: "wrap", width: "100%" }}>
                                <img src="/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg" loading="lazy" style={{ width: "40px", height: "60px", objectFit: "cover", borderRadius: "5px" }} />
                              </div>
                              <div class="player-status bgwinner" style={{ color: "rgb(0, 0, 0)", marginTop: "5px", fontSize: "14px", fontWeight: "bold", textAlign: "center", width: "100%" }}>
                                WINNER
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            );
          })}

      </div>
      <style>
        {`
          .no-border {
            border-bottom: none !important;
          }
        `}
      </style>
    </div>
  );
}

export default HiLowResult;



